import {observer} from 'mobx-react';
import {TwitterPicker} from 'react-color';
import {withState, t} from 'shared/core';
import SubNav from 'main/containers/company_settings/SubNav';
import {Button, Panel, Layout} from 'shared/components';
import PlatformCustomizationState from '../state/PlatformCustomizationState';
import {FormattedMessage} from 'react-intl';

const PlatformCustomizationContainer = observer(({uiState}) => {
  const {company} = uiState;

  return (
    <div>
      <SubNav title={t('company_settings.subnav.Platform Customization')}/>
      <Layout>
        <Panel>
          <Panel.Header title={t('company_settings.platform_customization.Platform Colour')}/>
          <div className='flex justify-content-between align-items-end flex-wrap'>
            <div className='flex flex-wrap align-items-start'>
              <div className='flex flex-col align-items-middle mr2'>
                <div
                  className='rounded'
                  style={{
                    width: 96,
                    height: 96,
                    backgroundColor: company.platformColor,
                  }}
                />
              </div>
              <div className='mr2'>
                <TwitterPicker
                  color={company.platformColor}
                  colors={['#1B3EAE', '#0693E3', '#30A80F', '#FCB900', '#EBA134', '#EB144C', '#E67591', '#9900EF', '#838D96', '#43494F']}
                  triangle='hide'
                  onChangeComplete={color => uiState.updatePlatformColor(color.hex.toUpperCase())}
                />
              </div>
            </div>
            <div className='flex justify-content-end mt2'>
              <Button onClick={() => uiState.saveColor()}>
                {<FormattedMessage id='company_settings.platform_customization.Save'/>}
              </Button>
            </div>
          </div>
        </Panel>
      </Layout>
    </div>
  );
});

export default withState(PlatformCustomizationContainer, PlatformCustomizationState);
